module.exports = __webpack_public_path__ + "img/order_success_animation_frame_3.aba65055.png";